(ns bp-clients.tv-app.pages.playlist
  (:require
   ["react" :refer [createRef]]
   ["react-intersection-observer" :refer [InView]]
   [bp-clients.tv-app.common.components.carousel :refer [carousel-3d]]
   [bp-clients.tv-app.common.components.tabs :as tab-components]
   [bp-clients.tv-app.common.components.thumb :as thumb-components]
   [bp-clients.tv-app.common.events :as common-events]
   [bp-clients.tv-app.nav.events :as nav-events]
   [bp-clients.tv-app.nav.subs :as nav-subs]
   [bp-clients.tv-app.utils.bff
    :refer [filter-not-supported-types]]
   [bp-clients.tv-app.utils.keycodes :as keycodes]
   [bp-clients.tv-app.utils.utils
    :refer [cloudinary-image get-percentage] :as utils]
   [bp-clients.tv-app.utils.window :as window]
   [bp-libs.design-system.components.banner :refer [main]]
   [bp-libs.design-system.components.carousel :refer [carousel]]
   [bp-libs.design-system.components.icons :as icons]
   [bp-libs.design-system.components.progress :refer [continue-watching-bar]]
   [bp-libs.design-system.components.thumb :refer [thumb]]
   [bp-libs.design-system.components.title-details :refer [title-details]]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(defn media-progress-complete?
  "Checks if a media progress is complete."
  [completion-percentage]
  (> completion-percentage 90))

(defn- gen-loading-shimmers
  [count]
  (mapv (fn [_] [thumb-components/safe-thumb {:container {:height "320px" :width "220px"}}]) (range count)))

(defn- carousel-with-title
  [title thumbs {:keys [thumb-size id]}]
  (let [ref             (createRef)
        block-ref       (createRef)
        in-view         (r/atom false)
        update-inview   #(reset! in-view (or %1 @in-view))
        title-component [:div {:class "text-white text-lg font-medium pl-2 carousel"
                               :ref   block-ref} title]
        calculate-step  #(str (+ (js/parseFloat %) 0.933) "rem")
        thumb-width     (:width (get thumb-components/aspect-ratio->container thumb-size "16:9"))]
    (fn []
      (when (seq thumbs)
        [:div {:class    "py-1"
               :key      id
               :on-focus #(.scrollIntoView (-> block-ref .-current) (clj->js {:block "start"
                                                                              :inline "nearest"
                                                                              :behavior "smooth"}))}
         (if-not @in-view
           [:> InView {:as "div" :onChange update-inview :className "h-full" :threshold 0.01}
            title-component
            [carousel {:thumbs (gen-loading-shimmers 10)}]]
           [:div
            title-component
            [carousel-3d {:thumbs    thumbs
                          :step-3d   (calculate-step thumb-width)
                          :react-ref ref}]])]))))

(defn- gen-episodes-thumbs
  [medias on-item-click]
  (doall
   (for [media medias]
     ^{:key (str (:id media) "-" (or (-> media :progress :completion_percentage) ""))}
     [thumb-components/carousel-thumb (merge media on-item-click)])))

(defn- rating-component
  [active-item]
  [:div {:style {:height "24px"}}
   [thumb {:container {:width "24px" :height "24px"}
           :image-url (-> active-item :banner :general_info :rating :url)}]])

(defn- tab-with-carousel
  "For now, we suppose that a tab always
  will have exactly one carousel.
  One tab per module, each module composed by
  one media carousel.

  Maybe in the future we can have cases that
  we want to show episodes as a grid. Example:
  Conversa Paralela, that have too many episodes
  per season."
  [on-item-click tab]
  ;; @todo mount components recursively
  (let [episodes-thumbs
        (gen-episodes-thumbs (-> tab :components first :items) on-item-click)
        aspect-ratio (some-> tab :components first :items first :thumbnail :aspect_ratio)

        tab-items-carousel
        ^{:key (str "carousel-" (:label tab))}
        [carousel-with-title nil
         episodes-thumbs {:id         (str "carousel-" (:label tab))
                          :thumb-size aspect-ratio}]]
    (assoc tab :carousel tab-items-carousel)))

(defn- on-thumb-focus
  [item]
  (rf/dispatch [::nav-events/set-active-item item]))

(defn- on-thumb-click
  [playlist thumb]
  (if (= "tv_app_go_to_paywall_page" (-> thumb :event :__typename))
    (rf/dispatch [::nav-events/open-paywall (:event thumb)])
    (do (rf/dispatch [::nav-events/set-active-item thumb])
        (rf/dispatch [::common-events/open-player thumb {:slug playlist}]))))

(defn- main-button-click-fn [main-banner-btn]
  (if (= "tv_app_go_to_paywall_page" (-> main-banner-btn :event :__typename))
    #(rf/dispatch [::nav-events/open-paywall (:event main-banner-btn)])
    #(rf/dispatch [::common-events/open-player
                   {:id (-> main-banner-btn :event :media_id)}
                   {:slug (-> main-banner-btn :event :playlist_slug)}])))

(defn- product-progress-notification
  [{:keys [product-title active-module active-module-playlists modules-progression]}]
  (let [active-module-playlists-watched (filter true? active-module-playlists)
        active-module-watched-percent   (get-percentage (count active-module-playlists-watched)
                                                        (count active-module-playlists))
        total-playlists                 (apply + (map count modules-progression))
        total-playlists-watched         (apply + (map #(->> % (filter true?) count) modules-progression))
        total-watched-percent           (get-percentage total-playlists-watched
                                                        total-playlists)
        finished?                       (= total-playlists total-playlists-watched)]
    [:div {:class "absolute right-4 top-6 w-1/4 mt-0 z-10"}
     [:div {:class "flex  bg-black text-white py-4 px-8 text-xl rounded-lg"}
      [:div {:class "w-1/5 -ml-4 text-gray-500"}
       [icons/medal {:width 64
                     :height 64}]]
      [:div {:class "w-full space-y-2"}
       [:h1 {:class "font-medium"}
        (str "Certificação " product-title)]
       [:div {:class "w-full flex text-gray-400 font-medium"}
        [:p {:class "whitespace-nowrap"}
         (str total-playlists-watched " de " total-playlists)]
        [:p {:class "w-full pl-2 pt-3"}
         [continue-watching-bar {:width total-watched-percent
                                 :height "h-2"
                                 :foreground-class "bg-success-500"}]]]
       (if finished?
         [:div {:class "text-success-500 flex items-center"}
          [icons/check {:width 26
                        :height 26}]
          [:p {:class "text-xl"}
           "Certificação Concluída"]]

         [:p {:class "font-normal"}
          "Para obter o certificado complete todas as aula dos módulos do " product-title])]]
     [:div {:class "flex bg-black text-white py-4 px-8 text-xl rounded-lg mt-2"}
      [:div {:class "w-1/5 -ml-4"}]
      [:div {:class "w-full space-y-2"}
       [:h1 {:class "font-medium"} (:label active-module)]
       [:div {:class "w-full flex text-gray-400 font-medium pr-8"}
        [:p {:class "whitespace-nowrap"}
         (str (count active-module-playlists-watched) "/" (count active-module-playlists))]
        [:p {:class "w-full pl-2 pt-3"}
         [continue-watching-bar {:width active-module-watched-percent
                                 :height "h-2"
                                 :foreground-class "bg-success-500"}]]]]]]))

(defn- focus-on-content []
  (js/setTimeout (fn []
                   (.focus js/SpatialNavigation "content"))
                 utils/delay-to-focus))

(defn- focus-on-details-button [details-btn-ref]
  (js/setTimeout (fn []
                   (when (and details-btn-ref (.-current details-btn-ref))
                     (.focus (.-current details-btn-ref))))
                 utils/delay-to-focus))

(defn- open-details [playlist show-details?]
  (rf/dispatch [:bp-clients.tv-app.analytics.events/screen-requested {:view :playlist-details
                                                                      :item-id playlist}])
  (reset! show-details? true)
  (js/setTimeout (fn []
                   (.focus js/SpatialNavigation "overlay"))
                 utils/delay-to-focus))

(defn- close-details [show-details?]
  (reset! show-details? false)
  (js/setTimeout (fn []
                   (.focus js/SpatialNavigation "content"))
                 utils/delay-to-focus))

(defn playlist
  []
  (let [opened-details?         (r/atom false)
        banner-main-button-ref  (createRef)
        details-back-button-ref (createRef)
        details-button-ref      (createRef)
        details-scroll-ref      (createRef)
        active-page-data        (rf/subscribe [::nav-subs/active-page-data])
        active-playlist         (rf/subscribe [::nav-subs/active-playlist])]
    (focus-on-content)
    (fn []
      (let [{:keys [components] :as active-item}     @active-page-data
            playlist                                 @active-playlist
            window-size                              (window/size)
            components                               (filter-not-supported-types components #{"tv_app_tab_set" "tv_app_carousel"})
            components                               (keep-indexed (fn [i c]
                                                                     (assoc c :index i)) components)
            thumb-config                            {:tab-index (:content utils/navigation-selectors)
                                                     :on-focus on-thumb-focus
                                                     :on-click (partial on-thumb-click playlist)}
            rating-image                             [rating-component active-item]
            banner-info                              (-> active-item :banner :general_info)
            advisories                               (-> banner-info :rating :advisory)
            logo                                     (cloudinary-image (:logo banner-info)
                                                                       {:trim? true
                                                                        :width (some-> window-size :width (/ 3) js/Math.ceil)})
            title                                    (:title banner-info)
            playlist-type                            (-> active-item :type)
            extra-info                               (-> banner-info :extra_info (or []))
            keep-watching-info                       (:keep_watching_info banner-info)
            tags                                     (filter (comp not nil?) (concat extra-info (apply vector rating-image advisories)))
            background-thumb-url                     (cloudinary-image (:background_image banner-info))
            main-banner-btn                          (-> active-item :banner :main_button)

            keep-watching-completion-percentage      (-> keep-watching-info :completion_percentage)
            keep-watching-time-left                  (-> keep-watching-info :remaining_description)
            keep-watching-media-description          (-> keep-watching-info :current_media_description)
            {:keys [previous]}                       keycodes/k->event-code
            on-details-back                          (fn [_]
                                                       (reset! opened-details? false)
                                                       (focus-on-details-button details-button-ref))]
        [:<>
         [:div {:class ["top-0 fixed left-0 w-screen h-screen"
                        "transition-opacity duration-1000 ease-in-out delay-100"
                        (if @opened-details? "opacity-100 z-50" "z-0 opacity-0")]}
          [title-details {:on-back              on-details-back
                          :on-key-down          #(let [key-code (.-keyCode %)]
                                                   (utils/stop-event-propagation %)
                                                   (cond
                                                     (and (keycodes/down? key-code)
                                                          (some-> details-scroll-ref .-current .-scrollBy))
                                                     (-> details-scroll-ref
                                                         .-current
                                                         (.scrollBy (clj->js {:top      50
                                                                              :behavior "smooth"})))
                                                     (and (keycodes/up? key-code)
                                                          (some-> details-scroll-ref .-current .-scrollBy))
                                                     (-> details-scroll-ref
                                                         .-current
                                                         (.scrollBy (clj->js {:top      -50
                                                                              :behavior "smooth"})))

                                                     (or (contains? (set previous) key-code)
                                                         (keycodes/ok? key-code))
                                                     (do (rf/dispatch [:bp-clients.tv-app.analytics.events/screen-requested
                                                                       {:view :playlist-page
                                                                        :item-id playlist}])
                                                         (close-details opened-details?)
                                                         (focus-on-details-button details-button-ref))))
                          :scroll-ref           details-scroll-ref
                          :tab-index            (:overlay utils/navigation-selectors)
                          :rating               (:rating banner-info)
                          :logo-url             logo
                          :title                title
                          :react-ref            details-back-button-ref
                          :background-thumb-url background-thumb-url
                          :teachers             (:teachers banner-info)
                          :cast                 (:cast banner-info)
                          :directors            (:directors banner-info)
                          :duration             (:duration banner-info)
                          :release-year         (:release_year banner-info)
                          :description          (:description banner-info)}]]
         [:div {:class ["bg-black min-h-screen pl-8 relative"
                        (when @opened-details? "opacity-0")
                        "transition-opacity duration-1000 ease-in-out"]}
          [:div {:class ["h-[60vh] pl-2 overflow-hidden"]
                 :key (str playlist (:__typename active-item))}
           ^{:key (hash (str playlist keep-watching-completion-percentage keep-watching-media-description))}
           [main {:details-button       {:on-click    #(open-details playlist opened-details?)
                                         :react-ref   details-button-ref
                                         :on-key-down #(let [key-code (.-keyCode %)]
                                                         (cond
                                                           (keycodes/ok? key-code)
                                                           (do (utils/stop-event-propagation %)
                                                               (open-details playlist opened-details?))

                                                           (or (keycodes/up? key-code)
                                                               (keycodes/right? key-code))
                                                           (utils/stop-event-propagation %)))}
                  :tags                 tags
                  :description          (:description banner-info)
                  :title                (:title banner-info)
                  :is-loading?          (nil? active-item)
                  :tab-index            (:content utils/navigation-selectors)
                  :hide-banner?         (nil? logo)
                  :keep-watching                   keep-watching-completion-percentage
                  :keep-watching-time-left         keep-watching-time-left
                  :keep-watching-media-description keep-watching-media-description
                  :main-button          (assoc main-banner-btn
                                               :react-ref banner-main-button-ref
                                               :on-key-down #(let [key-code (.-keyCode %)]
                                                               (when (keycodes/up? key-code)
                                                                 (utils/stop-event-propagation %)))
                                               :on-click (main-button-click-fn main-banner-btn))
                  :banner-logo-url      logo
                  :background-thumb-url background-thumb-url}]]
          [:div {:class ["h-[50vh] isolate overflow-scroll z-10 space-y-10 -mt-[10vh] hide-scroll-bar pl-8 last:pb-60"]}
           (doall
            #_{:clj-kondo/ignore [:used-underscored-binding]}
            (for [{:keys [__typename] :as component} components]
              (case __typename
                "tv_app_tab_set"
                (let [tabs              (map (partial tab-with-carousel thumb-config) (:tabs component))
                      active-tab-index  (r/atom (or (:active_tab_index component) 0))
                      active-card-index (:active_card_index component)
                      tabs-progression  (map #(->> %
                                                   :components
                                                   first
                                                   :items
                                                   (map (comp media-progress-complete? :completion_percentage :progress)))
                                             tabs)]
                  ^{:key (str "tab-" (hash component))}
                  [:div
                   [tab-components/tabs tabs active-tab-index active-card-index]

                   (when (= playlist-type "produto")
                     [(fn [] [product-progress-notification {:product-title title
                                                             :active-module (nth tabs @active-tab-index)
                                                             :active-module-playlists (nth tabs-progression @active-tab-index)
                                                             :modules-progression tabs-progression}])])])

                "tv_app_carousel"
                (let [episodes-thumbs (gen-episodes-thumbs (:items component) thumb-config)
                      aspect-ratio    (some-> component :items first :thumbnail :aspect_ratio)]
                  ^{:key (str "carousel-" (hash component))}
                  [:div
                   [carousel-with-title (:title component)
                    episodes-thumbs {:id         (:title component)
                                     :thumb-size aspect-ratio}]]))))

           (when-not components
             (let [shimmers (gen-loading-shimmers 10)]
               [:div {:class "animate-pulse space-y-10"}
                [carousel-3d {:thumbs shimmers}]
                [carousel-3d {:thumbs shimmers}]]))]]]))))
